import Crud from '../components/User/Crud'
import Entity from '../components/User/Add'
import View from '../components/User/View'
import Edit from '../components/User/Edit'
import Reset from '../components/User/Reset'

let routes = {
    path: '/users',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'Novo Usuário',
            component: Entity
        },
        {
            path: '/users/edit/:id?',
            name: 'Editar Usuário',
            component: Edit
        },
        {
            path: '/users/view/:id?',
            name: 'Visualizar Usuário',
            component: View
        },
        {
            path: '/users',
            name: 'Usuários',
            component: Crud
        },
        {
            path: '/users/resetpassword/:id?',
            name: 'Alterar Senha',
            component: Reset
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/user.js